import React, { useEffect, useRef, useState } from "react";

import SideMenu from "../General/SideMenu";
import Messagedialogbox, { Pre_Loading, Show_Message } from "../General/Messagedialogbox";
import CustomizedSelectoption from "../General/CustomizedSelectoption";
import { useDispatch, useSelector } from "react-redux";
import { API_FETCH, API_POST, DecryptData } from "../General/Utility";
import ReactTable from "../General/ReactTable";
import TransProductSearch from "../Transaction/TransProductSearch";
import {
  setScrId,
  ShowHide_Popup,
  Clear_Product,
  ProductInput_Onchange,
  Select_Unit,
  Select_Product,
} from "../features/Transactionstates";

// ─── Helper: safely pick first non-null value from multiple key names ─────────
const pick = (obj, ...keys) => {
  if (!obj) return undefined;
  for (const key of keys) {
    if (obj[key] !== undefined && obj[key] !== null) return obj[key];
  }
  return undefined;
};

// ─── Helper: safe date — fallback to today if blank / invalid ─────────────────
const safeDate = (val) => {
  if (!val || val === "0000-00-00" || String(val).trim() === "")
    return new Date().toISOString().split("T")[0];
  return val;
};

const iScrId = 37;

function OpenStock() {
  const dispatch    = useDispatch();
  const _AuthParems = useSelector((state) => state.Common.Admin);
  const _selecrparem = useSelector((state) => state.SelectOption.parems);
  const _Common     = useSelector((store) => store.Transstates.Common);
  const _Product    = useSelector((store) => store.Transstates.Product);

  const dQtyRef = useRef(null);

  const [selected,           setselected]           = useState(0);
  const [bUpdateStatus,      setbUpdateStatus]      = useState(false);
  const [strBatchNo,         setstrBatchNo]         = useState("");
  const [dpManufactureDate,  setdpManufactureDate]  = useState(new Date().toISOString().split("T")[0]);
  const [dpExpiryDate,       setdpExpiryDate]       = useState(new Date().toISOString().split("T")[0]);
  const [arrProduct,         setarrProduct]         = useState([]);
  const [strSearchTable,     setstrSearchTable]     = useState("");

  // ─── Mount ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    dispatch(setScrId(iScrId));
    Load_OpenStock();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ─── Load saved stock list ─────────────────────────────────────────────────
  const Load_OpenStock = async () => {
    try {
      const _LocalParems = await DecryptData(localStorage.jbctrlparams);
      const res = await API_FETCH(
        `OpenStock/Load_OpenStocks/${Number(_LocalParems.Branch)}/${_LocalParems.DB}`,
        dispatch
      );
      if (res && res.strStatus === "Success") {
        const list = pick(res, "objEntProduct", "ObjEntProduct") || [];
        setarrProduct(Normalize_List(list));
      } else if (res) {
        Show_Message(dispatch, res.strMessage || "Failed to load stock", "error");
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    }
  };

  // ─── Normalize — handles PascalCase & camelCase from API ──────────────────
  const Normalize_List = (list) => {
    if (!Array.isArray(list)) return [];
    return list.map((row, index) => ({
      ...row,
      sNo:             index + 1,
      proId:           pick(row, "proId", "ProId"),
      proName:         pick(row, "proName", "ProName")             || "",
      attValues:       pick(row, "attValues", "AttValues")         || "",
      batchNo:         pick(row, "batchNo", "BatchNo")             || "",
      manufactureDate: safeDate(pick(row, "manufactureDate", "ManufactureDate")),
      expiryDate:      safeDate(pick(row, "expiryDate", "ExpiryDate")),
      unitName:        pick(row, "unitName", "UnitName")           || "",
      unitId:          pick(row, "unitId", "UnitId"),
      qty:             Number(pick(row, "qty", "Qty"))             || 0,
      isBatchPro:      pick(row, "isBatchPro", "IsBatchPro")       ?? 0,
      isComposPro:     pick(row, "isComposPro", "IsComposPro")     ?? 0,
    }));
  };

  // ─── Save ──────────────────────────────────────────────────────────────────
  const Save_OpenStock = async () => {
    if (arrProduct.length === 0) {
      Show_Message(dispatch, "No products to save", "info");
      return;
    }
    try {
      await Pre_Loading(dispatch, true);
      const res = await API_POST(
        "OpenStock/Update_OpenStock/",
        {
          objModel:   arrProduct,
          strDBName:  _AuthParems.DB,
          iUserid:    Number(_AuthParems.User),
          iBranchId:  Number(_AuthParems.Branch),
        },
        dispatch
      );
      if (res && res.strStatus === "Success") {
        Show_Message(dispatch, res.strMessage, "success");
        await Clear_OpenStock();
      } else if (res) {
        Show_Message(dispatch, res.strMessage || "Save failed", "error");
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Delete by sNo — safe for same product with different batches ──────────
  const Delete_OpenStock = (Row) => {
    if (!window.confirm(`Delete "${Row.proName}" from the list?`)) return;
    let updated = arrProduct.filter((dt) => dt.sNo !== Row.sNo);
    updated = updated.map((dt, idx) => ({ ...dt, sNo: idx + 1 }));
    setarrProduct(updated);
  };

  // ─── Double-click row → load into form for editing ────────────────────────
  const Assign_Product = async (proinfo) => {
    try {
      await Pre_Loading(dispatch, true);
      const objTrans = {
        iScrId:      iScrId,
        ScrType:     "Purchase",
        strScrType:  "Purchase",
        iPartyId:    0,
        iTaxRelId:   0,
        Search:      "",
        iWHId:       0,
        iBranchId:   Number(_AuthParems.Branch),
        strDBName:   _AuthParems.DB,
        iProId:      proinfo.proId,
        isComposPro: proinfo.isComposPro ?? 0,
        isBatchPro:  proinfo.isBatchPro  ?? 0,
        isAttPro:    0,
        iAttGrpId:   0,
        TransType:   "Transaction",
      };
      const res = await API_POST(`ProductTrans/View_Product/`, objTrans, dispatch);
      if (res && res.strStatus === "Success") {
        if (res.EntProduct && res.EntProduct.length > 0) {
          res.ProInfo = res.EntProduct;
          res.ProUnit = res.EntUOM || [];
          res.WHId    = 0;
          dispatch(Select_Product(res));

          // ── FIX: Select_Product resets dQty to product-master default (e.g. 1).
          // We must re-apply the ACTUAL qty & unit already saved for this row,
          // otherwise the Qty box always shows the default instead of proinfo.qty.
          dispatch(ProductInput_Onchange({ Name: "dQty", Value: proinfo.qty }));
          if (proinfo.unitId) {
            dispatch(Select_Unit({ UnitId: Number(proinfo.unitId), dPriceRate: 0 }));
          }
        }
        setbUpdateStatus(true);
        setselected(proinfo.sNo - 1);
        setstrBatchNo(proinfo.batchNo || "");
        setdpManufactureDate(safeDate(proinfo.manufactureDate));
        setdpExpiryDate(safeDate(proinfo.expiryDate));
        setTimeout(() => dQtyRef.current?.focus(), 100);
      } else if (res) {
        Show_Message(dispatch, res.strMessage || "Product load failed", "error");
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Expiry date validation ────────────────────────────────────────────────
  const Validate_Dates = () => {
    if (dpExpiryDate && dpManufactureDate && dpExpiryDate < dpManufactureDate) {
      Show_Message(dispatch, "Expiry Date cannot be before Manufacture Date", "info");
      return false;
    }
    return true;
  };

  // ─── Add / Update product row ──────────────────────────────────────────────
  const Add_Product = async () => {
    if (!_Product.iProId || _Product.iProId === 0) {
      Show_Message(dispatch, "Please select a product", "info");
      return;
    }
    if (!_Product.dQty || Number(_Product.dQty) <= 0) {
      Show_Message(dispatch, "Minimum Qty is required", "info");
      return;
    }
    if (!Validate_Dates()) return;

    // Duplicate guard — new add only, not update
    if (!bUpdateStatus) {
      const isDuplicate = arrProduct.some(
        (p) => p.proId === _Product.iProId && (p.batchNo || "") === strBatchNo
      );
      if (isDuplicate) {
        Show_Message(
          dispatch,
          "Product with same batch already added. Double-click the row to edit.",
          "info"
        );
        return;
      }
    }

    try {
      await Pre_Loading(dispatch, true);
      const res = await API_POST(
        "OpenStock/AddStock/",
        {
          bUpdateStatus:     bUpdateStatus,
          iRowIndex:         selected,
          iProId:            _Product.iProId,
          dQty:              Number(_Product.dQty),
          iUnitId:           Number(_Product.iUnitId),
          strBatchNo:        strBatchNo,
          strManufactureDate: dpManufactureDate,
          strExpiryDate:     dpExpiryDate,
          strProAttDTId:     "0",
          strStoAttDTId:     "0",
          strTraAttDTId:     "0",
          strDBName:         _AuthParems.DB,
          objEntDT:          arrProduct,
        },
        dispatch
      );
      if (res && res.strStatus === "Success") {
        const list = pick(res, "objEntDT", "ObjEntDT") || [];
        setarrProduct(Normalize_List(list));
        Clear_ProductForm();
      } else if (res) {
        Show_Message(dispatch, res.strMessage || "Add failed", "error");
      }
    } catch (e) {
      Show_Message(dispatch, e.message, "error");
    } finally {
      await Pre_Loading(dispatch, false);
    }
  };

  // ─── Clear product form only ───────────────────────────────────────────────
  const Clear_ProductForm = () => {
    setselected(0);
    setbUpdateStatus(false);
    setstrBatchNo("");
    setdpManufactureDate(new Date().toISOString().split("T")[0]);
    setdpExpiryDate(new Date().toISOString().split("T")[0]);
    dispatch(Clear_Product());
  };

  // ─── Clear full screen + reload ───────────────────────────────────────────
  const Clear_OpenStock = async () => {
    Clear_ProductForm();
    setarrProduct([]);
    setstrSearchTable("");
    await Load_OpenStock();
  };

  // ─── Table columns ─────────────────────────────────────────────────────────
  const Column = [
    {
      Header: "S.No",
      accessor: "sNo",
      maxWidth: 50,
      style: { justifyContent: "center" },
    },
    {
      Header: "Product Name",
      accessor: "proName",
      style: { justifyContent: "left" },
    },
    {
      Header: "Attributes",
      accessor: "attValues",
      style: { justifyContent: "left", color: "gray" },
    },
    {
      Header: "Batch No",
      accessor: "batchNo",
      maxWidth: 110,
      style: { justifyContent: "center" },
    },
    {
      Header: "Mfg Date",
      accessor: "manufactureDate",
      maxWidth: 130,
      style: { justifyContent: "center" },
    },
    {
      Header: "Exp Date",
      accessor: "expiryDate",
      maxWidth: 110,
      style: { justifyContent: "center" },
      cell: ({ rowinfo }) => {
        const today = new Date().toISOString().split("T")[0];
        const expired = rowinfo.expiryDate && rowinfo.expiryDate < today;
        return (
          <span style={{ color: expired ? "red" : "inherit", fontWeight: expired ? "600" : "normal" }}>
            {rowinfo.expiryDate || ""}
          </span>
        );
      },
    },
    {
      Header: "Unit",
      accessor: "unitName",
      maxWidth: 100,
      style: { justifyContent: "center" },
    },
    {
      Header: "Qty",
      accessor: "qty",
      maxWidth: 100,
      cell: ({ rowinfo }) => Number(rowinfo.qty || 0).toFixed(2),
      style: { justifyContent: "right" },
    },
    {
      Header: "Delete",
      style: { justifyContent: "center" },
      minWidth: 50,
      maxWidth: 50,
      cell: ({ rowinfo }) => (
        <i
          onClick={() => Delete_OpenStock(rowinfo)}
          className="far fa-trash-alt"
          style={{ cursor: "pointer", color: "red" }}
        />
      ),
    },
  ];

  // ─── Filtered list ─────────────────────────────────────────────────────────
  const filteredProducts = arrProduct.filter((p) =>
    (p.proName || "").toLowerCase().includes((strSearchTable || "").toLowerCase())
  );

  // ─── Render ────────────────────────────────────────────────────────────────
  return (
    <>
      <SideMenu ScrId={iScrId} />
      <div className="Trans-container">
        <div className="Trans-card">
          <div className="Trans-wrapper">

            {/* ── Search bar ── */}
            <div className="row mb-2">
              <div className="col-sm-12 col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search in added stock list..."
                  value={strSearchTable}
                  onChange={(e) => setstrSearchTable(e.target.value)}
                  autoComplete="off"
                />
              </div>
            </div>

            {/* ── Product entry form ── */}
            <div className="row">

              {/* Product Name */}
              <div className="col-sm-12 col-md-4">
                <label>Product Name <span className="danger">*</span></label>
                <div className="custom-select" style={{ position: "relative" }}>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Click to Select Product"
                    value={_Product.strProName}
                    onChange={() => {}}
                    autoComplete="off"
                    onKeyDown={(e) => { if (e.key === "Enter") dispatch(ShowHide_Popup("IsProSearch")); }}
                    onClick={() => dispatch(ShowHide_Popup("IsProSearch"))}
                  />
                  <i
                    className="fa-solid fa-caret-down"
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: _Common.IsProSearch
                        ? "translateY(-50%) rotate(-180deg)"
                        : "translateY(-50%) rotate(0deg)",
                      color: "darkgreen",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>

              {/* Qty */}
              <div className="col-sm-12 col-md-2">
                <label>Qty <span className="danger">*</span></label>
                <input
                  type="number"
                  className="form-control"
                  ref={dQtyRef}
                  value={_Product.dQty}
                  onChange={(e) =>
                    dispatch(ProductInput_Onchange({ Name: "dQty", Value: e.target.value }))
                  }
                  onClick={(e) => e.target.select()}
                  min={0}
                />
              </div>

              {/* Unit */}
              <div className="col-sm-12 col-md-2">
                <label>Unit</label>
                <CustomizedSelectoption
                  optionparem="isoptionShow3"
                  showoption={_selecrparem.isoptionShow3}
                  placeholder="Select Unit"
                  select_value={(val) =>
                    dispatch(Select_Unit({ UnitId: Number(val), dPriceRate: 0 }))
                  }
                  btnname="Unit"
                  btnshow={false}
                  show_popup=""
                  valueonly={true}
                  defaultval={_Product.iUnitId}
                  displayName="strUnitName"
                  disvalue="iUnitId"
                  arrydata={_Product.Unit}
                  disabled={_Product.iProId === 0}
                  EmptVal="Unit"
                />
              </div>

              {/* Batch No */}
              <div className="col-sm-6 col-md-2">
                <label>Batch No</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Batch No"
                  value={strBatchNo}
                  onClick={(e) => e.target.select()}
                  onChange={(e) => setstrBatchNo(e.target.value)}
                />
              </div>

              {/* Add / Update */}
              <div className="col-sm-6 col-md-1 btn-col">
                <label>&nbsp;</label>
                <button type="button" onClick={Add_Product} className="btn-fabgreen">
                  {bUpdateStatus ? "Update" : "Add"}&nbsp;
                  <i className="bx bx-layer-plus" />
                </button>
              </div>

              {/* Clear form */}
              <div className="col-sm-6 col-md-1 btn-col">
                <label>&nbsp;</label>
                <button type="button" onClick={Clear_ProductForm} className="btn-fabgreen btn-outline">
                  Clear
                </button>
              </div>

              {/* Manufacture & Expiry Date */}
              <div className="row mt-2">
                <div className="col-sm-6 col-md-2">
                  <label>Manufacture Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dpManufactureDate}
                    onChange={(e) => setdpManufactureDate(e.target.value)}
                  />
                </div>
                <div className="col-sm-6 col-md-2">
                  <label>Expiry Date</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dpExpiryDate}
                    onChange={(e) => setdpExpiryDate(e.target.value)}
                  />
                </div>
              </div>

              {/* Product table */}
              <div className="col-sm-12 mt-2">
                <ReactTable
                  columns={Column}
                  data={filteredProducts}
                  minRows={10}
                  row_click={(rowInfo, Index) => setselected(Index)}
                  row_doubleclick={(rowInfo) => Assign_Product(rowInfo)}
                  background={true}
                  className="full-table"
                />
              </div>
            </div>
          </div>

          {/* ── Footer buttons ── */}
          <div className="btn-section">
            <button type="button" className="btn-fabgreen" onClick={Save_OpenStock}>
              Save &nbsp;<i className="bx bxs-save" />
            </button>
            <button type="button" className="btn-fabgreen" onClick={Clear_OpenStock}>
              Clear &nbsp;<i className="fa-solid fa-broom" />
            </button>
            <button
              type="button"
              className="btn-fabgreen"
              onClick={() => (window.location.href = `/JustBill/DashBoard`)}
            >
              Close &nbsp;<i className="fas fa-times" />
            </button>
          </div>

          {_Common.IsProSearch && (
            <TransProductSearch addedProducts={arrProduct} />
          )}
          <Messagedialogbox />
        </div>
      </div>
    </>
  );
}

export default OpenStock;